import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { PkgShippingMethod } from '@/api/user-package/types/UserPkg'
import { Divider } from '@/components/Divider'
import ClockIcon from '@/components/icons/clock.svg?react'
import CostIcon from '@/components/icons/cost.svg?react'
import PackageIcon from '@/components/icons/package.svg?react'
import SuccessIcon from '@/components/icons/success.svg?react'
import { Button } from '@/components/ui/button'
import { getShippingMethodLabel } from '@/helpers/pkgUtils'
import { RoutePath } from '@/RoutePath'

const addBusinessDays = (date: Date, days: number) => {
  let count = 0
  const result = new Date(date)
  while (count < days) {
    result.setDate(result.getDate() + 1)
    const dayOfWeek = result.getDay()
    // Skip weekends (Saturday=6, Sunday=0)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count++
    }
  }
  return result
}

interface Props {
  shippingMethod: PkgShippingMethod
  displayPrice: number
  onClose: () => void
}
export function PaymentSuccessDialog({ shippingMethod, displayPrice, onClose }: Props) {
  const { t } = useTranslation()

  const today = new Date()
  const minDate = addBusinessDays(today, 14)
  const maxDate = addBusinessDays(today, 21)
  const deliveryDateRange = t('payment.deliveryDateRange', { minDate, maxDate })

  return (
    <div className='flex flex-col items-center gap-4'>
      <div className='h-6 w-6'>
        <SuccessIcon className='text-icon-primary h-full w-full' />
      </div>

      <div className='flex flex-col items-center gap-4'>
        <h2 className='text-text-primary text-center text-base font-medium'>{t('payment.packageOnTheWay')}</h2>
        <p className='text-text-secondary text-center text-sm'>
          {t('payment.successMessage')}
          <br />
          {t('payment.successMessage2')}
          <br />
          {t('payment.successMessage3')}
        </p>
      </div>

      <div className='bg-button-primary-selected-segment w-full rounded-lg p-4'>
        <div className='flex flex-col gap-2'>
          <div className='flex items-center gap-2'>
            <CostIcon className='text-text-secondary size-4' />
            <span className='text-text-secondary text-sm'>
              {t('payment.shippingCostTotal')} {displayPrice} ₪
            </span>
          </div>

          <div className='flex items-center gap-2'>
            <PackageIcon className='text-text-secondary size-4' />
            <span className='text-text-secondary text-sm'>
              {t('payment.shippingType')}: {getShippingMethodLabel(shippingMethod, t)}
            </span>
          </div>

          <div className='flex items-center gap-2'>
            <ClockIcon className='text-text-secondary size-4' />
            <span className='text-text-secondary text-sm'>
              {t('payment.deliveryExpected')} {deliveryDateRange}
            </span>
          </div>
        </div>
      </div>
      <p className='text-text-secondary self-start text-xs'>{t('payment.cancelBeforeShip')}</p>
      <Divider />
      <Link to={RoutePath.ClientPkg} onClick={onClose}>
        <Button size='sm' variant='ghost' className='text-text-link text-sm'>
          {t('payment.backToPackages')}
        </Button>
      </Link>
    </div>
  )
}
